import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SavingEmitterService {
  public savingBool = new EventEmitter();
  constructor() { }

  sendMessage(bool: boolean) {
    this.savingBool.emit(bool);
  }
}
